import { isBoolean, isEmpty, isNil, isObject } from 'lodash';
import moment, { Moment } from 'moment-timezone';

export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm:ss A';
export const DATE_TIME_FORMAT_USER_REPORT = 'MM-DD-YYYY hh:mm:ss';
export const DATE_TIME_FORMAT_REPORTED_USER = 'MM/DD/YYYY hh:mm A';
export const DATE_TIME_FORMAT_EVENT = 'MM/DD/YYYY h:mm A';

export const getFormattedDate = (
	date: Date | string | undefined,
	format = DATE_FORMAT,
) => getFormattedLocalDate(date, format);

export const getFormattedDateTime = (
	date: Date | string | undefined,
	format = DATE_TIME_FORMAT,
) => getFormattedLocalDate(date, format);

export const getFormattedDateWithTz = (date?: Date | string) =>
	getFormattedLocalDate(date, DATE_TIME_FORMAT_EVENT, true);

export const getFormattedLocalDate = (
	date: Date | string | undefined,
	format = DATE_TIME_FORMAT,
	withTz = false,
) => {
	if (!date) return '';

	return (
		moment.parseZone(date).local().format(format) +
		(withTz ? moment.tz(moment.tz.guess(true)).format(' z') : '')
	);
};

export const disableFutureDates = (current: Moment) => {
	return current && current > moment().endOf('day');
};

export const getCellValue = (value: any) => {
	if (
		isNil(value) ||
		value === '' ||
		isBoolean(value) ||
		(isObject(value) && isEmpty(value))
	) {
		return '—';
	}

	return value;
};
